import { IkasCustomerAttribute } from ".";
import { IkasCustomerAttributeTranslation } from "./translation";

export function initIkasCustomerAttribute(
  attribute: IkasCustomerAttribute,
  locale: string | null
) {
  if (attribute.translations && locale) {
    setTranslations(attribute, attribute.translations, locale);
    delete attribute.translations;
  }
}

function setTranslations(
  attribute: IkasCustomerAttribute,
  translations: IkasCustomerAttributeTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name) attribute.name = localeTranslations.name;
    if (localeTranslations?.description)
      attribute.description = localeTranslations.description;
    if (localeTranslations?.options) {
      attribute.options?.forEach((o) => {
        const translatedVV = localeTranslations.options?.find(
          (to) => to.id === o.id
        );
        if (translatedVV && translatedVV.name) o.name = translatedVV.name;
      });
    }
  }
}
